import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import lineItemStyles from '../LineItem.module.scss'
import styles from './Header.module.scss'

/**
 * The `Header`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Header = forwardRef((props, forwardedRef) => {
  const { children, className } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () => classNames([className, lineItemStyles.header, styles.header]),
    [className]
  )

  return (
    <div ref={ref} className={classNameOutput}>
      {children}
    </div>
  )
})

// Display name
Header.displayName = 'Header'

/** @type {object} */
Header.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

/** @type {object} */
Header.defaultProps = {
  children: null,
  className: ''
}

// Memoize
export default memo(Header)
